<script>
  import http from '../api/http.js';
  import WidgetCard from '../components/WidgetCard.svelte';
  import { onMount, onDestroy } from 'svelte';
  import { selectedGroup, currentPage } from '../store.js';
  import { Card, CardBody, CardHeader, CardFooter, Pagination, PaginationLink, PaginationItem, Spinner, Button } from 'sveltestrap';
  import formatDate, { formatJustDate } from '../Helpers/DateTimeFormatter'
  import Search from '../components/Search.svelte';
  import TableColumn from '../components/TableColumn.svelte';
  import Select from 'svelte-select';
  import { Link } from 'svelte-routing'; 
	import WidgetCardAlt from '../components/WidgetCardAlt.svelte';

  const installedFilterState = 'installed';
  const notInstalledFilterState = 'notinstalled';
  const requiresUpgradeFilterState = 'requiresupgrade';

  const groupBy = (item) => item.group;
  let filterState = installedFilterState;
  let isLoading = false;
  let totalInstalledCount = 0;
  let notInstalledCount = 0;
  let requiresUpgradeCount = 0;
  let totalComputersCount = 0;
  let searchRefresh = false;
  let inputLength = 0
  let searchTerm = "";
  let packages = [];
  let previousPageNumber = 0;
  let pageNumber = 1;
  let totalPageCount = 0;
  let tableHeader = 'Installed';
  let computers = [];
  const displayNumbers = [10, 25, 50, 100, 200];
  let displayNumber = displayNumbers[0];
  let sortType = {
    ascending: 'ascending',
    descending: 'descending',
    resting: 'resting'
  }

  let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };
  let selectedPackage = {
      value: 0,
      label: ''
  };

  let selectedComputers = [];
  let allComputerSelected = false;
  

  $: {
      if ($selectedGroup != undefined) {
        loadPackages();
      }
  }

    $:{
        selectedPackage;
        loadCountsAndComputers();
    }
  
  $:{
      pageNumber;
      displayNumber;
      loadComputers(filterState, activeColumn.columnValue, activeColumn.sortType);
    }

  $: {
      if (previousPageNumber != pageNumber) {
      previousPageNumber = pageNumber;
    }
  }

  $:{
    filterState;
    resetSelections();
    }

  onDestroy(() => {
    clearInterval(interval);
  });

  async function searchComputers(){ 
    searchRefresh = true;    
    let interval = setInterval( async () => {
      if(searchTerm.length != inputLength){
        pageNumber = 1;
        loadComputers(filterState, activeColumn.columnValue, activeColumn.sortType);   
      }   
      if(!searchRefresh){
        clearInterval(interval);
      }
      inputLength = searchTerm.length;      
    }, 2000);    
  }

  function setFilter(filter){
    if(filter == installedFilterState){
        tableHeader = "Installed";
        filterState = installedFilterState;
    }
    else if(filter == notInstalledFilterState){
        tableHeader = "Not Installed";
        filterState = notInstalledFilterState;
    }
    else if(filter == requiresUpgradeFilterState){
        tableHeader = "Requires Upgrade";
        filterState = requiresUpgradeFilterState;
    }
  }

  const interval = setInterval(loadCountsAndComputers(), 30000);

  async function loadCountsAndComputers(){
    await loadWidgetCounts();
    await loadComputers(filterState, activeColumn.columnValue, activeColumn.sortType);
  }

  function setPageNumber(number){
    pageNumber = number;    
  }

  async function loadWidgetCounts(){
    if(selectedPackage.value != 0){
      let countsRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/computers/bysoftware/count/${$selectedGroup}/${selectedPackage.value}`);

      if(countsRes.status == 200){
        let counts = await countsRes.json();
        totalInstalledCount = counts[0];
        notInstalledCount = counts[1];
        requiresUpgradeCount = counts[2];
      }
      else{
        totalInstalledCount = 0;
        notInstalledCount = 0;
        requiresUpgradeCount = 0;
      }
    }
    
  }
  
  const loadPackages = async () => {
    const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/managed/forselect/${$selectedGroup}`);
    packages = await res.json();
    if (packages.length > 0) {
      selectedPackage = packages[0];       
    }
    else{
      packages = [];
      selectedPackage = {
        value: 0,
        label: ''
      };
    }
  }
  
  async function loadComputers(filterState, columnValue, sortTypeArg){
    computers = [];
    if(selectedPackage.value != 0){
      if(!isLoading){
        let ascending = sortTypeArg == sortType.ascending ? true : false;
        let url = "";
        if(columnValue == undefined){
            columnValue = 5;
        }
        if(ascending == undefined){
            ascending = true;
        }
        isLoading = true;
        if(searchTerm.length > 0 && searchTerm != ""){
          url = `/deploy/dashboard/computers/bysoftware/${$selectedGroup}/${searchTerm}/${displayNumber}/${pageNumber}/${filterState}/${columnValue}/${ascending}/${selectedPackage.value}`;
        }
        else{
          url = `/deploy/dashboard/computers/bysoftware/${$selectedGroup}/${displayNumber}/${pageNumber}/${filterState}/${columnValue}/${ascending}/${selectedPackage.value}`;
        }
        const res = await http.get(window.apiBaseUrl + url);
        if(res.status == 200){
          let uiComputersCollection = await res.json();
          computers = uiComputersCollection.registryEntries;
          totalPageCount = uiComputersCollection.totalPageCount;    
          totalComputersCount = uiComputersCollection.noPaginationComputerCount          
        }
        else{
          computers = [];
        }
        isLoading = false;
      }
    }
  }

  function toggleSort(columnValue, theSortType){
    if(activeColumn.value != columnValue){
      activeColumn.columnValue = columnValue;    
    }
    switch(theSortType){
      case sortType.resting:      
        activeColumn.sortType = sortType.ascending;      
        break;
      case sortType.ascending:
        activeColumn.sortType = sortType.descending;
        break;
      case sortType.descending:
        activeColumn.sortType = sortType.ascending;
        break;
    }
    
    if(activeColumn.sortType != sortType.resting){
      loadComputers(filterState, columnValue, activeColumn.sortType);
    }
  }

  async function createDeployment(computer, multideploy){
    isLoading = true;
    let postRequest;
    let computerIds;
    if(multideploy == true){
      computerIds = selectedComputers.map(c => c.id);     
    }
    else{
      computerIds = [ computer.id ];
    }

    postRequest = await http.post(window.apiBaseUrl + `/deploy/dashboard/command/combined/${selectedPackage.value}/${$selectedGroup}`, computerIds);
    isLoading = false;

    if(postRequest.status == 200){      
      loadComputers(filterState, activeColumn.columnValue, activeColumn.sortType);
      resetSelections();
    }
  }

  const selectComputer = (computer) =>{
    if (computer.selected) {
        selectedComputers.push(computer);
    }
    else {
      selectedComputers = selectedComputers.filter(v => v.id != computer.id);
    }
    selectedComputers = selectedComputers;
    computers = computers;
  }

  const toggleSelectAllComputers = () =>{
    if (allComputerSelected) {
      computers.forEach(computer => {
        if(computer.processingCommand == 0){
          computer.selected = true;
          if(!selectedComputers.map(c => c.id).includes(computer.id)){
            selectedComputers.push(computer);
          }
        }        
      });
    }
    else {
      computers.forEach(computer => {
        if(computer.processingCommand == 0){
          computer.selected = false;
          selectedComputers = [];
        }        
      });
    }
    computers = computers;
    selectedComputers = selectedComputers;
  }

  const resetSelections = () => {
    computers.forEach(computer => {
        computer.selected = false;
    });
    allComputerSelected = '';
    selectedComputers = [];        
  }

</script>

<div class="mt-2">
  <p>This list displays all software deployed throughout your fleet that was packaged and is managed by the deployment tool.</p>
</div>
<div class="flex mb-2 mt-4">
  <label class="pt-2" for="package-name">Package Name</label>  
  <div>
    <Select id="package-select" isClearable={false} isSearchable={true} bind:selectedValue={selectedPackage} items={packages} {groupBy}></Select> 
  </div>
</div>
<div class="grid" id="grid">
    <WidgetCardAlt isWidget="true" id="total-installed-widget" title="Installed" value="{totalInstalledCount}" icon="check" color="primary" withFooter=true on:mousedown={() => setFilter(installedFilterState)} active={filterState == installedFilterState} disabled={isLoading}></WidgetCardAlt>
    <WidgetCardAlt isWidget="true" id="not-installed-widget" title="Not Installed" value="{notInstalledCount}" icon="ban" color="tertiary" withFooter=true on:mousedown={() => setFilter(notInstalledFilterState)} active={filterState == notInstalledFilterState} disabled={isLoading}></WidgetCardAlt>
    <WidgetCardAlt isWidget="true" id="requires-upgrade-widget" title="Requires Upgrade" value="{requiresUpgradeCount}" icon="exclamation-triangle" color="secondary" withFooter=true on:mousedown={() => setFilter(requiresUpgradeFilterState)} active={filterState == requiresUpgradeFilterState} disabled={isLoading}></WidgetCardAlt>
</div>
<Card>
  <CardHeader>
    <div class="row">
        <div class="col-sm">
            <h6 class="font-weight-bold mt-2 mb-2">{tableHeader}</h6>
        </div>
        {#if isLoading}
          <Spinner color="primary" type="border"></Spinner>
        {/if}
         <div class="col-sm">
            <Search id="computer-search-input" bind:searchTerm placeholder="Search Computers..." on:input={() => searchComputers()}></Search>   
         </div>
         <div class="col-sm">
            <Button id="deploy-selected-button" disabled={isLoading || selectedComputers.length == 0} on:click={() => createDeployment(null, true)} class="float-right" color="primary">Deploy Selected</Button>          
         </div>           
    </CardHeader>
  <CardBody>
    {#if computers.length == 0}
      <p>No computers to display.</p>
    {:else}
      <div class="table-responsive">
        <table class="table" width="100%" cellspacing="0">
          <thead>
            <th>
              {#if (filterState == notInstalledFilterState || filterState == requiresUpgradeFilterState) && computers.length > 0 && computers.filter(c => c.processingCommand == 0).length > 0}
                <input id="select-all-computers" type="checkbox" bind:checked={allComputerSelected} on:change={() => toggleSelectAllComputers()}/>{selectedComputers.length > 0 ? `(${selectedComputers.length})` : ''}
              {/if}              
            </th>
            <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Vessel</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Computer</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>Application</TableColumn>
            {#if filterState == installedFilterState || filterState == requiresUpgradeFilterState}
              <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} active={activeColumn.columnValue == 6} sortType={activeColumn.sortType}>Install Date</TableColumn>
              <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Version Number</TableColumn>
              <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Latest Available Version</TableColumn>
              <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>Publisher</TableColumn>
            {/if}
            <th>Actions</th>
          </thead>
          <tbody>
            {#each computers as computer}
              <tr id="computer-row-{computer.id}">
                <td>
                  {#if (filterState == notInstalledFilterState || filterState == requiresUpgradeFilterState) && computer.processingCommand == 0}
                    <input id="computer-checkbox-{computer.id}" type="checkbox" bind:checked={computer.selected}  on:change={() => selectComputer(computer)}/>
                  {/if}
                </td>
                <td>{computer.vesselName}</td>
                <td>{computer.hostName}</td>
                <td>{computer.applicationName}</td>
                {#if filterState == installedFilterState || filterState == requiresUpgradeFilterState}
                  {#if computer.installDate == "Data not available"}
                    <td>Data not available</td>
                  {:else}
                    <td>{formatJustDate(computer.installDate)}</td>
                  {/if}
                  <td>{computer.versionNumber}</td>
                  <td>{computer.latestVersionNumber}</td>  
                  <td>{computer.publisher}</td>
                {/if}
                <td>
                  {#if (filterState == notInstalledFilterState || filterState == requiresUpgradeFilterState)}
                    {#if computer.processingCommand == 0}
                      <Button size="sm" id="deploy-button-{computer.id}" disabled={isLoading} on:click={() => createDeployment(computer, false)} color="primary">Deploy Latest</Button>
                    {:else if computer.processingCommand == 1}
                      <Link to="/deployment/{computer.vesselName}">View deployment status</Link>                    
                    {:else}
                      <Link to="/commands/{computer.vesselName}">View command status</Link>
                    {/if}
                  {/if}
                </td>
              </tr>            
            {/each}
          </tbody>
        </table>
      </div>
    {/if}    
  </CardBody>
  <CardFooter>
    <div class="pagination bg-light shadow-none ml-0 d-flex">
      {#if computers.length == 0}
        <small class="mt-3 mr-auto">0 - 0 of 0 computers</small>
      {:else}
        {#if searchTerm.length > 0 && searchTerm != ""}
        <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalComputersCount ? totalComputersCount:pageNumber * displayNumber)} of {totalComputersCount} computers</small>
        {:else}
          <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalComputersCount ? totalComputersCount:pageNumber * displayNumber)} of {totalComputersCount} computers</small>
        {/if}
      {/if}          
      <div class="mt-2 justify-content-center">
         <Pagination>
            <PaginationItem disabled={pageNumber == 1}>
              <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
            </PaginationItem>

            <PaginationItem  disabled={pageNumber == 1}>
              <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
            </PaginationItem>

            {#if totalPageCount > 5}
              {#each Array(5) as _, count}
                {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                  <PaginationItem active={pageNumber == count + pageNumber} >
                    <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber <= 3}
                  <PaginationItem active={pageNumber == count + 1} >
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber >= totalPageCount - 2}
                  <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                    <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                  </PaginationItem>
                {/if}
              {/each}
            {:else}
              {#each Array(totalPageCount) as _, count}
                <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {/each}
            {/if}      

            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
            </PaginationItem>
            
            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
            </PaginationItem>
          </Pagination>
      </div>
      <div class="mt-3 ml-auto">
        <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
          {#each displayNumbers as displayNumber}
            <option value={displayNumber}>{displayNumber}</option>
          {/each}
        </select>
        <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
      </div>  
    </div>
  </CardFooter>
</Card>

<style>
  .grid {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        display: grid;
        gap: 1em;
        margin-top: 0.25em;
        margin-bottom: 1.0em;
    }

    .flex-g{
      flex-grow: 1;
    }
</style>